import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updatePickSessionItemQuantity = {
  name: "updatePickSessionItemQuantity" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    updates: z.array(
      z.object({ itemId: zExt.objectId(), quantityPicked: z.number().min(0) }),
    ),
  }),
  output: z.object({
    success: z.boolean(),
    updatedPickSession: PickSessionSchema.nullish(),
  }),
};
